import { useState } from 'react';
import { api } from '../App';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Database, ArrowsClockwise } from '@phosphor-icons/react';

const sum = (o) => Object.values(o || {}).reduce((a, b) => a + (typeof b === 'number' ? b : sum(b)), 0);

export const TenantMigrationCard = ({ onDone }) => {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);

  const check = async () => {
    setBusy(true);
    try { setRows((await api.get('/admin/tenant-migration/status')).data); }
    catch (e) { toast.error(e.response?.data?.detail || 'Greška pri provjeri'); }
    finally { setBusy(false); }
  };

  const run = async () => {
    setBusy(true);
    try {
      const r = await api.post('/admin/tenant-migration/run');
      toast.success(`Prebačeno ${r.data.total_inserted} zapisa`);
      await check();
      onDone?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Greška pri prebacivanju'); }
    finally { setBusy(false); }
  };

  return (
    <Card className="p-5 border-amber-200 bg-amber-50/40" data-testid="tenant-migration-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Database size={22} weight="duotone" className="text-amber-600" />
          <div>
            <h4 className="font-semibold text-slate-900">Prebacivanje podataka workspace-a</h4>
            <p className="text-xs text-slate-600">Kopira podatke iz starih baza u novu strukturu. Bezbjedno je pokrenuti više puta, ništa se ne briše.</p>
          </div>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={check} disabled={busy} data-testid="tenant-migration-check-btn">Provjeri</Button>
          <Button onClick={run} disabled={busy} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="tenant-migration-run-btn">
            <ArrowsClockwise size={18} className={`mr-2 ${busy ? 'animate-spin' : ''}`} /> Prebaci podatke
          </Button>
        </div>
      </div>
      {rows && (
        <table className="w-full text-sm mt-4" data-testid="tenant-migration-table">
          <thead><tr className="text-left text-slate-500"><th className="py-1">Workspace</th><th>Stara baza (zapisa)</th><th>Nova struktura (zapisa)</th></tr></thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} className="border-t border-amber-100" data-testid={`tenant-migration-row-${r.id}`}>
                <td className="py-1">{r.name}</td>
                <td>{sum(r.sources)}</td>
                <td className={sum(r.destination) < sum(r.sources) ? 'text-red-600 font-semibold' : 'text-green-700'}>{sum(r.destination)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Card>
  );
};
